import {DataTransferObjectValidation} from "../../../type/Types";
import {CampaignValueObject} from "../../vo/campaign/CampaignValueObject";

export namespace CampaignDataTransferObject {
    export type Post = {
        landingUrl: string
        title: string
        description: string
        bannerImageUrl: string
        iconImageUrl: string
        category: string
        point : number
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = CampaignValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            landingUrl(o: string): string {
                return o
            },
            title(o: string): string {
                return o
            },
            description(o: string): string {
                return o
            },
            bannerImageUrl(o: string): string {
                return o
            },
            iconImageUrl(o: string): string {
                return o
            },
            category(o: string): string  {
                return o
            },
            point(o: string): number {
                return Number(o)
            },

        }
    }

    export type Put = {
        landingUrl: string
        title: string
        description: string
        bannerImageUrl: string
        iconImageUrl: string
        category: string
        point : number
    }

    export namespace Put {
        export const description: Record<keyof Put, string> = CampaignValueObject.description

        export const validation: DataTransferObjectValidation<Put> = {
            landingUrl(o: string): string {
                return o
            },
            title(o: string): string {
                return o
            },
            description(o: string): string {
                return o
            },
            bannerImageUrl(o: string): string {
                return o
            },
            iconImageUrl(o: string): string {
                return o
            },
            category(o: string): string  {
                return o
            },
            point(o: string): number {
                return Number(o)
            },
        }
    }
}

